import React from "react";
import Select from "react-select";

export default class MsDropdown extends React.PureComponent {
    constructor(props) {
        super(props);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    handleInputChange = (newValue) => {
        if (newValue) {
            this.props.onChange(newValue.value.trim());
        }
    };

    render() {
        let divClass =
            "ui icon input formRow--input-wrapper js-inputWrapper " +
            this.props.classes; // <%= payload %>
        let divId = this.props.id + "_field";
        let borderColor = this.props.showError ? "#FF0000" : "#22242626";
        let colourStyles = {
            container: (styles) => ({
                ...styles,
                width: "100%",
                height: 38,
                zIndex: 1000,
            }),
            control: (styles) => ({
                ...styles,
                height: 38,
                borderColor: borderColor,
            }),
            valueContainer: (styles) => ({ ...styles, height: 38 }),
            indicatorsContainer: (styles) => ({ ...styles, height: 38 }),
            input: (styles) => ({ ...styles, height: 30 }),
            menuPortal: (styles) => ({ ...styles, zIndex: 10000 }),
        };
        let selectedValue = null;
        this.props.values.forEach((v) => {
            if (v.value == this.props.value) {
                selectedValue = v;
                return;
            }
        });
        return (
            <div className="field">
                <fieldset className="formRow">
                    <>
                        <label style={{ fontSize: "12px" }} for={divId}>
                            {this.props?.label}
                        </label>
                        <div id={divId} className={divClass}>
                            <Select
                                defaultValue={selectedValue}
                                options={this.props.values}
                                styles={colourStyles}
                                onChange={this.handleInputChange}
                                placeholder={this.props.label}
                                menuPortalTarget={document.body}
                                menuPosition={"fixed"}
                            />
                        </div>
                    </>
                </fieldset>
            </div>
        );
    }
}
